<template>
  <!-- Karta z formularzem resetu hasła -->
  <div class="card m-3 text-center">
    <!-- Nagłówek formularza -->
    <h4 class="card-header">{{ t('reset-password') }}</h4>
    <div class="d-flex card-body justify-content-center">
      <!-- Formularz z walidacją -->
      <Form
        @submit="onSubmit"
        :validation-schema="schema"
        v-slot="{ errors, isSubmitting }"
      >
        <!-- Pole e-mail -->
        <div class="form-group row mb-1">
          <label class="col-sm-2 col-form-label">{{ t('email') }}</label>
          <div class="col-sm-10">
            <Field
              name="email"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': errors.email }"
            />
            <!-- Komunikat o błędzie -->
            <div class="invalid-feedback">{{ errors.email }}</div>
          </div>
        </div>

        <!-- Instrukcja i przycisk wysyłania -->
        <div class="form-group row d-flex flex-column align-items-center">
          <div class="col-auto">
            {{ t('type-your-email-send-reset-token') }}
          </div>
          <div class="col-auto">
            <button
              class="btn btn-outline-secondary mt-3"
              :disabled="isSubmitting"
            >
              <span
                v-show="isSubmitting"
                class="spinner-border spinner-border-sm mr-1"
              ></span>
              {{ t('send-email') }}
            </button>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>

<script setup>
// Importy niezbędnych narzędzi i bibliotek
import { useAuthStore } from "@/stores/auth.store";
import { Form, Field } from "vee-validate";
import * as Yup from "yup";
import { useI18n } from 'vue-i18n';

// Hook do tłumaczeń
const { t } = useI18n();

// Definicja schematu walidacji dla pola e-mail
const schema = Yup.object({
  email: Yup.string()
    .email(t('incorrect-email-address'))        // komunikat przy niepoprawnym mailu
    .required(t('user-email-required')),        // komunikat przy pustym polu
});

// Funkcja obsługująca submit formularza (reset hasła)
async function onSubmit(values) {
  const { email } = values;
  const authStore = useAuthStore();
  // Wywołuje metodę resetPassword ze store
  await authStore.resetPassword(email);
}
</script>

<style scoped>
.card-body {
  background: #f5f4f3;
}
.card-body form {
  width: 400px;
}
.col-form-label {
  text-align: right;
  line-height: 25px;
}
.form-group {
  font-size: 12px;
}
button {
  border: 0;
  color: #231f20;
  font-size: 15px;
  font-weight: bold;
}
a {
  color: #231f20;
  font-size: 12px;
  text-decoration: none;
}
input {
  border: 0;
  border-left: 1px solid #c8c7c7;
  border-top: 1px solid #c8c7c7;
  padding: 10px;
}
input:focus {
  border-color: #c8c7c7;
  box-shadow: 0 0 0 0.25rem rgba(100, 101, 104, 0.25);
}
</style>
